export default __webpack_public_path__ + "static/media/TrashIcon.1870ffad.svg";